import { render } from "./myHome.vue?vue&type=template&id=7eda9cda&scoped=true"
import script from "./myHome.vue?vue&type=script&lang=js"
export * from "./myHome.vue?vue&type=script&lang=js"

import "./myHome.vue?vue&type=style&index=0&id=7eda9cda&lang=less&scoped=true"

import exportComponent from "/Users/chenli/Documents/buzzbuzz/第九工场/my-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eda9cda"]])

export default __exports__